// A TWO-OR-MORE-WAY SWITCH IN THE SIDEBAR'S FOOT: the language's, the viewer's shape. Coloured like
// the sidebar's own tabs above it (navClass): the chosen side a faint blue tint, its label white so it
// reads at a glance — a solid blue-600 was the loudest thing on the rail.
export function PillToggle<T extends string>({ options, value, onChange }: {
  options: readonly { value: T; label: string; icon?: string }[];
  value: T;
  onChange: (value: T) => void;
}) {
  return (
    <div className="inline-flex items-center gap-0.5 rounded-lg border border-slate-300 bg-white p-0.5 shadow-sm dark:border-white/10 dark:bg-slate-900 dark:shadow-none">
      {options.map((o) => {
        const active = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => onChange(o.value)}
            aria-pressed={active}
            aria-label={o.label}
            className={`flex items-center gap-1 rounded-md px-2 py-1 text-xs font-semibold transition-colors ${
              active
                ? 'bg-blue-500/15 text-slate-900 dark:text-white'
                : 'text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-200'
            }`}
          >
            {o.icon && <span aria-hidden>{o.icon}</span>}
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
